import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import ActionItems from './ActionItems';
import AddLanguageButton from 'components/AddLanguageButton';
import { message } from 'antd';
import { handleMessage } from 'utils/helper/message';
import AddModal from './AddModal';
import {
  IAbility,
  IAbilityLocalization,
  IItem,
  IItemLocalize,
  IModalVisible,
} from 'utils/types/storyTypes';
import EditModal from './EditModal';
import { useTranslation } from 'react-i18next';
import SupportLangContext from 'context/SupportLangContext';

interface IProps {
  targetData: IItem | IAbility | null; // 로컬라이징 정보를 포함하고있는 대상정보 (item, profile 등등)
  setTargetData: React.Dispatch<React.SetStateAction<any>>; // 타겟 데이터 state 처리용

  visibleState: IModalVisible; // 팝업 활성, 비활성 정보
  setVisibleState: React.Dispatch<React.SetStateAction<IModalVisible>>;

  currentLocalDataArray: any[] | undefined;
  targetLocalize: string;
  columnName: string;
}

// 2개 컬럼을 지원하는 다국어 지원 테이블
// 주 목적은 localizations array 편집.
const TwoColumnLocalizeSupporter: React.FC<IProps> = ({
  targetData,
  setTargetData,

  visibleState,
  setVisibleState,

  currentLocalDataArray,

  targetLocalize,

  columnName,
}) => {
  const { t } = useTranslation();
  const langList = useContext(SupportLangContext); // 제작 언어 리스트
  const [localizeTextIndex, setLocalizeTextIndex] = useState<number>(0);

  // 언어 추가 버튼 눌렀을때.
  const onClickAddLang = () => {
    setVisibleState({ ...visibleState, create: true });
  };

  useEffect(() => {
    // 각각 타겟 데이터마다 텍스트 array가 다르다.
  }, [targetData]);

  return (
    <>
      <SectionWarpper>
        <div className='langsTable'>
          <div className='langsTable-first'>
            <p className='title-table'>지원 언어</p>
          </div>
          <div className='langsTable-second'>
            <p className='title-table'>{columnName}</p>
          </div>
          <div className='langsTable-third'></div>
          {/* 타겟에 따라서(ability, item) 서로 다른 컬럼을 사용... */}
          {targetLocalize == 'item'
            ? targetData?.localizations?.map((ldata, i) => {
                return (
                  <>
                    <div className='langsTable-first' key={i}>
                      <p
                        key={i}
                        className={
                          !ldata.id || ldata.updated ? 'changed-text' : 'title'
                        }
                      >
                        {ldata?.lang}
                      </p>
                    </div>
                    <div className='langsTable-second' key={i + 10}>
                      <p
                        key={i + 10}
                        className={
                          !ldata.id || ldata.updated ? 'changed-text' : 'title'
                        }
                      >
                        {ldata?.item_name}
                      </p>
                    </div>
                    <div className='langsTable-third' key={i + 100}>
                      <ActionItems
                        textIndex={i}
                        visibleState={visibleState}
                        setVisibleState={setVisibleState}
                        setTextIndex={setLocalizeTextIndex}
                      />
                    </div>
                  </>
                );
              })
            : targetData?.localizations?.map((ldata, i) => {
                return (
                  <>
                    <div className='langsTable-first' key={i}>
                      <p
                        key={i}
                        className={
                          !ldata.id || ldata.updated ? 'changed-text' : 'title'
                        }
                      >
                        {ldata?.lang}
                      </p>
                    </div>
                    <div className='langsTable-second' key={i + 10}>
                      <p
                        key={i + 10}
                        className={
                          !ldata.id || ldata.updated ? 'changed-text' : 'title'
                        }
                      >
                        {ldata?.ability_name}
                      </p>
                    </div>
                    <div className='langsTable-third' key={i + 100}>
                      <ActionItems
                        textIndex={i}
                        visibleState={visibleState}
                        setVisibleState={setVisibleState}
                        setTextIndex={setLocalizeTextIndex}
                      />
                    </div>
                  </>
                );
              })}

          <AddLanguageButton handleAddLanguage={onClickAddLang} />
        </div>
      </SectionWarpper>
      <AddModal
        langList={langList}
        targetData={targetData}
        setTargetData={setTargetData}
        visibleState={visibleState}
        setVisibleState={setVisibleState}
        firstColumnName={columnName}
        currentLocalDataArray={currentLocalDataArray}
      />
      <EditModal
        langList={langList}
        targetData={targetData}
        setTargetData={setTargetData}
        visibleState={visibleState}
        setVisibleState={setVisibleState}
        firstColumnName={columnName}
        selectedTextRow={
          currentLocalDataArray ? currentLocalDataArray[localizeTextIndex] : 0
        }
        textIndex={localizeTextIndex}
      />
    </>
  );
};

export default TwoColumnLocalizeSupporter;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
  .langsTable {
    display: flex;
    flex-wrap: wrap;
  }
  .langsTable-first {
    width: 40%;
  }
  .langsTable-second {
    width: 40%;
  }
  .langsTable-third {
    width: 20%;
    display: flex;
    justify-content: end;
    & > * + * {
      margin-left: 16px;
    }
  }
  .langsTable-first,
  .langsTable-second,
  .langsTable-third {
    border-bottom: 1px solid ${theme.colors.dark_200};
    padding: 12px;
    display: flex;
    align-items: center;
    p {
      font-size: ${theme.fontSizes.sm};
      font-style: normal;
      font-weight: ${theme.fontWeights.medium};
      line-height: 16px;
      letter-spacing: 0.2px;
      /* text-transform: capitalize; */
    }
  }
  .title-table {
    font-size: ${theme.fontSizes.normal} !important;
    font-weight: ${theme.fontWeights.bold} !important;
  }
  .changed-text {
    color: ${theme.colors.red_400};
    font-weight: ${theme.fontWeights.bold} !important;
  }
`;
